import { allowedLicensePlateSymbols, licensePlatePatterns } from './patterns';
import { StringMask } from './string-mask';

export class LicensePlateNumberMask {
  static mask(value, patternLangs?: string[]): string {
    value = value
      ?.replace(new RegExp(`[^${allowedLicensePlateSymbols}]`, 'g'), '')
      .toUpperCase();

    let patternsToCheck = [];

    if (patternLangs?.length > 0) {
      patternLangs.forEach((patternLang) => {
        if (licensePlatePatterns[patternLang]) {
          patternsToCheck = patternsToCheck.concat(
            licensePlatePatterns[patternLang]
          );
        }
      });
    }

    if (value && patternsToCheck.length) {
      return LicensePlateNumberMask.setValueMask(value, patternsToCheck);
    }

    return value;
  }

  static setValueMask(value: string, patternsToCheck: any[]): string {
    let valid = false;
    let formatValue = value;

    for (let i = 0; !valid && i < patternsToCheck.length; i++) {
      const pattern = patternsToCheck[i].pattern;
      if (new RegExp(pattern).test(value)) {
        valid = true;

        if (patternsToCheck[i].mask) {
          const mask = new StringMask(patternsToCheck[i].mask).process(value);
          formatValue = mask?.valid ? mask?.result : value?.toLocaleUpperCase();
        }
      }
    }
    return formatValue;
  }
}
